export const REQUEST_CAMPAIGN_CATEGORY_PARENT_LIST = "REQUEST_CAMPAIGN_CATEGORY_PARENT_LIST"
export const REQUEST_CAMPAIGN_CATEGORY_LIST = "REQUEST_CAMPAIGN_CATEGORY_LIST"
export const REQUEST_CAMPAIGN_CATEGORY_LIST_FOR_CREATE = "REQUEST_CAMPAIGN_CATEGORY_LIST_FOR_CREATE"